<section *ngIf="upsellbookingStatus.showUpsellScreen && bookingInit && copyLoaded" class="col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 fadeInUp">
  <app-upsell-booking [appCopy]='appCopy' [selectedLanguage]="selectedLanguage">
  </app-upsell-booking>
</section>

<section class="fadeInUp" *ngIf="!upsellbookingStatus.showUpsellScreen">
  <div class="col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
    <div>
      <app-language-selector></app-language-selector>
      <button
        id="collection-back"
        type="button"
        class="btn btn-link hidden-sm hidden-xs back-btn"
        *ngIf="bookingType !== 'amend' && copyLoaded"
        (click)="goPanelBack()"
      >
        <i class="icon">chevron_left</i>{{appCopy.panelHeader['linkBack'+selectedLanguage]}}
      </button>
      <button
        type="button"
        class="btn btn-link back-btn"
        *ngIf="bookingType === 'amend' && copyLoaded"
        (click)="cancelAmend()"
      >
        <i class="icon">chevron_left</i>{{appCopy.panelHeader['linkCancel'+selectedLanguage]}}
      </button>
    </div>

    <div *ngIf="postOfficeLoading || !bookingInit || !copyLoaded" class="loader-container">
      <div class="subtitle"></div>
      <div class="timeslotTabs">
        <div></div>
        <div></div>
      </div>
      <div class="continuebtn"></div>
    </div>

    <h1 *ngIf="!postOfficeLoading && bookingInit && copyLoaded" class="margin-bottom-16 text-dark-blue h1">
      {{appCopy.panelHeader['content'+selectedLanguage]}}
    </h1>
  </div>

  <form *ngIf="!postOfficeLoading && bookingInit && copyLoaded"
    #formHubProductselection="ngForm"
    id="dropoff"
    name="formHubProductselection"
    novalidate
  >
    <div class="col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 margin-top-32 adeInUp">
      <!-- radio pills -->
      <div class="radio-pills hubdrop margin-bottom-32">
        <!-- AT Address -->
        <div *ngIf="bookingType !== 'amend'" class="radio radio--pill" >
          <input
            type="radio"
            name="collectionType"
            [id]="'collectionType' + 1"
            [value]="'atAddress'"
            [ngModel]="selectedAddressType"
            (change)="setSelectedAddressType('atAddress')"
            required
          />
          <label class="collection-label" [for]="'collectionType' + 1">
            <p class="label__display">
              <span class="label__checkbox"></span>
              {{appCopy.panelHeader['addressTypeHome'+selectedLanguage]}}
            </p>
            <div class="section-caption">
              <p class="label__date text-caption" [innerHTML]="appCopy.panelHeader['addressTypeHomeDescription'+selectedLanguage].replace('%s', customerResidentialAddress)">
              </p>
            </div>
            <p class="starting-price label__date text-caption">
              <b>{{appCopy.panelHeader['from'+selectedLanguage] + ' ' + minAddressPrice}}</b>
              <b *ngIf="bestPriceValue === 'addressPrice' && bookingType !== 'amend'" class="text-purple"> | {{appCopy.panelHeader['bestValue'+selectedLanguage]}}!</b>
            </p>
          </label>
        </div>

        <!-- At Post office -->
        <div class="radio radio--pill" >
          <input
            type="radio"
            name="collectionType"
            [id]="'collectionType' + 2"
            [value]="'atPostOffice'"
            [ngModel]="selectedAddressType"
            (change)="setSelectedAddressType('atPostOffice')"
            required
          />
          <label class="collection-label" [for]="'collectionType' + 2">
            <div class="label__display gap-8">
              <span class="flex">
                <span class="label__checkbox"></span>
                {{appCopy.panelHeader['addressTypePostOffice'+selectedLanguage]}}
              </span>
              <img width="30" src="./images/modal/swiss-post-logo.png" alt="">
            </div>
            <div class="section-caption">
              <p class="label__date text-caption">
                {{appCopy.panelHeader['addressTypePostOfficeDescription'+selectedLanguage]}}
                <span (click)="hubdropInfoModal()"  class="icon-information icon-black icon_18"></span>
              </p>
            </div>
            <p class="starting-price label__date text-caption">
              <b>{{appCopy.panelHeader['from'+selectedLanguage] + ' ' + minPostOfficePrice}}</b>
              <b *ngIf="bestPriceValue === 'postOfficePrice' && bookingType !== 'amend'" class="text-purple"> | {{appCopy.panelHeader['bestValue'+selectedLanguage]}}!</b>
            </p>
          </label>
        </div>
      </div>
      <!-- radio pills -->

      <section>
        <div *ngIf="selectedAddressType === 'atPostOffice' && bookingType === 'amend' && !isPostOfficeSelected">
          <h1 class="margin-bottom-16 text-dark-blue h1">Current address! (en)</h1>
          <div id="dropoffPostOffice" class="form-group form-group-lg">
            <input
              class="form-control text-dark-blue box-shadow"
              readonly
              [ngClass]="{ 'has-error': false }"
              id="dropoffPostOffice"
              name="dropoffPostOffice"
              ngControl="dropoffPostOffice"
              #dropoffPostOffice="ngModel"
              [(ngModel)]="location.addressLine2"
              type="text"
              required
              appCheckEmpty
            />
            <label class="text-dark-blue control-label" for="dropoffPostOffice">{{
              location.addressLine1
            }}</label>
            <!-- <a
              class="control-btn"
              (click)="clearInput()"
              href="javascript:void(0)"
            >
              <i class="icon">edit</i>
            </a> -->
          </div>
        </div>

        <div *ngIf="selectedAddressType === 'atPostOffice' && isPostOfficeSelected">
          <h1 class="margin-bottom-16 text-dark-blue h1">{{appCopy.panelHeader['postOfficeTitle'+selectedLanguage]}}</h1>
          <div id="dropoffPostOffice" class="form-group form-group-lg">
            <input
              class="form-control text-dark-blue box-shadow"
              readonly
              [ngClass]="{ 'has-error': false }"
              id="dropoffPostOffice"
              name="dropoffPostOffice"
              ngControl="dropoffPostOffice"
              #dropoffPostOffice="ngModel"
              [(ngModel)]="selectedPostOffice.addressLine2"
              type="text"
              required
              appCheckEmpty
            />
            <label class="text-dark-blue control-label" for="dropoffPostOffice">{{
              selectedPostOffice.addressLine1
            }}</label>
            <a
              class="control-btn"
              (click)="clearInput()"
              href="javascript:void(0)"
            >
              <i class="icon">edit</i>
            </a>
            <p
              class="help-block text-danger"
              *ngIf="dropoffPostOffice.invalid && dropoffPostOffice.dirty"
            >
              invalid post location
            </p>
          </div>
        </div>

        <div *ngIf="selectedAddressType === 'atPostOffice' && !isPostOfficeSelected">
          <h1 class="margin-bottom-16 text-dark-blue h1">{{appCopy.panelHeader['postOfficeTitle'+selectedLanguage]}}</h1>
          <app-post-office-lookup
            (handleSelection)="handlePostOfficeSelection($event)"
            [items]="items"
            [appCopy]="appCopy"
            [selectedLanguage]="selectedLanguage"
          >
          </app-post-office-lookup>
        </div>
      </section>
    </div>

    <section *ngIf="selectedAddressType === 'atPostOffice' && (isPostOfficeSelected || amendZoneId)">
      <!-- timeslot section -->
      <app-hubdrop-timeslots
        *ngIf="bookingInit && copyLoaded && (isPostOfficeSelected || amendZoneId)"
        [originalAirlineCode]="originalAirlineCode"
        [flightNumber]="flightNumber"
        [flightDateTime]="flightDateTime"
        [flightDirection]="flightDirection"
        [zoneInfo]="zoneInfo"
        [ccdAvailable]="ccdAvailable"
        [departureAirportCode]="departureAirportCode"
        [terminal]="terminal"
        [location]="location"
        [collectionDateTime]="collectionDateTime"
        [bookingProduct]="bookingProduct"
        [appCopy]="appCopy"
        [hasReserveError]="hasReserveError"
        [hasReserveExpiredError]="hasReserveExpiredError"
        [showLoader]="showLoader"
        [operatingCarrier]="operatingCarrier"
        [postOfficeData]="selectedPostOffice"
        [appCopy]="appCopy"
        [selectedLanguage]="selectedLanguage"
        [amendZoneId]="amendZoneId"
        [selectedAddressType]="selectedAddressType"
        [postOfficeItems]="items"
        (checkReserveTimeslotData)="checkReserveTimeslotData($event)"
        (sendBagNote)="sendBagNote($event)"
        (sendVirtualBags)="sendVirtualBags($event)"
        (sendBagItems)="sendBagItems($event)"
        (sendHasOversizedBag)="sendHasOversizedBag($event)"
        (goPanelBack)="goPanelBack($event)"
        (goPanelForward)="goPanelForward($event)"
      ></app-hubdrop-timeslots>
    </section>

    <div class="col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 fadeInUp margin-top-32">
      <button
      [ngStyle]="{display: selectedAddressType === 'atPostOffice' && isPostOfficeSelected || amendZoneId ? 'none' : 'block'}"
        style="margin-top: 200px"
        id="formBagPickupLocationEdit-submit"
        type="submit"
        class="btn btn-purple margin-bottom-32 btn-block"
        [disabled]="!selectedAddressType || selectedAddressType === 'atPostOffice' && !isPostOfficeSelected"
        (click)="onAtAddress()"
      >
        <div class="loader-container-btn" *ngIf="false">
          <div class="loader loader--white">
            <svg class="circular" viewBox="25 25 50 50">
              <circle class="path" cx="50" cy="50" r="20" />
            </svg>
          </div>
        </div>
        {{appCopy.panelHeader['buttonContinue'+selectedLanguage]}}
      </button>
    </div>
  </form>
</section>
